import { render, staticRenderFns } from "./SkeletonProductPicooc.vue?vue&type=template&id=6a306562&"
import script from "./SkeletonProductPicooc.vue?vue&type=script&lang=js&"
export * from "./SkeletonProductPicooc.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonProductPicooc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports